import { gql } from "@apollo/client"

export const sendConfirmaionMail = gql`
    mutation sendConfirmationMail($input: SendConfirmationMailDto!) {
        sendConfirmationMail(input: $input)
    }
`